<template>
  <div class="my-report mb-foot-2button">
    <DbsHeader
      header-title="利用内容"
      :click-back-button-event="backToDbsIndexPage"
    />

    <hr />

    <!-- シェアサイクル利用履歴-->
    <div class="content-block">
      <div class="block">
        <!-- 乗車ID -->
        <CycleInfo label="乗車ID" :value="dbsReport.id" />
        <!-- バイク番号 -->
        <CycleInfo label="バイク番号 " :value="dbsReport.cyc_name" />
        <!-- 貸出時刻 -->
        <CycleInfo label="貸出時刻 " :value="dbsReport.start_time" />
        <!-- 返却時刻 -->
        <CycleInfo label="返却時刻 " :value="dbsReport.end_time" />
        <!-- 貸出ポート -->
        <CycleInfo label="貸出ポート " :value="dbsReport.start_park_name" />
        <!-- 返却ポート -->
        <CycleInfo label="返却ポート " :value="dbsReport.end_park_name" />
        <!-- お支払い金額 -->
        <CycleInfo label="お支払い金額 " :value="`${dbsReport.emot_fee} 円`" />
        <!-- ご利用クーポン -->
        <CycleInfo
          label="ご利用クーポン "
          :value="
            dbsReport.coupons.length > 0
              ? dbsReport.coupons[0].master_pass_name
              : 'なし'
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateDbsMyReport",
  setup() {
    const store = useStore();
    const route = useRoute();

    const dbsReport = computed(() =>
      store.getters["dbs/reports"].find((e) => e.id === route.params.id)
    );

    // headerのbackButton用の処理。
    const backToDbsIndexPage = () => {
      nativeHandlerService.returnNativeDbsWithClose();
    };

    return {
      dbsReport,
      backToDbsIndexPage,
    };
  },
};
</script>

<style>
.my-report .content-block {
  width: 100%;
  padding: 0 0 16px;
}
.my-report .content-block .block {
  display: table;
  font-size: 13px;
}
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
</style>
